import { pathBuilder } from 'config/paths/index';

export const root = '/admin/company/email-logs';
export default pathBuilder(root);
